import { defaultTarjetasEmergencia } from "./state";

/**
 * Función para completar options del select de los modelos de tarjeta de emergencia
 * @param array modelos Array JSON con los modelos activos de tarjeta de emergencia
 */
export function setModelos(state,modelos) {
    state.modelos = [];
    modelos.forEach(p => {
        state.modelos.push({ value: p.id, text: p.descripcion, head_and_footer: p.encabezado_pie_pagina });
    });
}

/**
 * Función para seleccionar el option correspondiente al modelo de tarjeta de emergencia parametrizado
 * @param json dato Información del modelo de tarjeta de emergencia parametrizado
 */
export function setTarjetasEmergencia(state, dato) {
    if (dato !== null) {
        state.selectedTarjetasEmergencia = dato;
        state.selectedTarjetasEmergencia.editar = true;
    }
}

/**
 * Mutación para resetear la tarjeta de emergencia de la empresa.
 *
 * @export
 * @param {*} state
 */
export function resetdefaultTarjetasEmergencia(state) {
    Object.assign(state.selectedTarjetasEmergencia, defaultTarjetasEmergencia());
}
